import React, { useEffect, useState } from 'react'
import SearchBox from '../SearchBox/SearchBox'
import styles from './Ambulance.module.css'
import AmbulanceItem from './AmbulanceItem/AmbulanceItem'

function Ambulance() {

    const [filterCity,setFilterCity] = useState('')
    const [filterState,setFilterState] = useState('')
    const [stateLink,setStateLink] = useState()
    const [statewiseHelplines,setStatewiseHelplines]=useState([]);


    useEffect(()=>{
        getStateWiseHelplines()
      },[])

      const getStateWiseHelplines=()=>{
        fetch('Helplines.json'
        ,{
          headers : { 
            'Content-Type': 'application/json',
            'Accept': 'application/json'
           }
        }
        )
          .then((response) => {
            return response.json();
          })
          .then((myJson) => {
            setStatewiseHelplines(myJson.helplines.sort((a, b) => (a.state).toLowerCase() > (b.state).toLowerCase() ? 1:-1 ).map((state)=>(
                {
                    state:state.state,
                    Ambulance:state.Ambulance,
                    stateHelpline:state.stateHelpline,
                    district:state.district,
                }
            )))
          })
      }

    return (
        <div className={styles.component}>
            <div className={styles.searchResults}>
                <h1>Ambulance & Helplines</h1>
                <SearchBox setFilterCity={setFilterCity} setFilterState={setFilterState}/>
                {
                    
                    statewiseHelplines.map((state)=>{
                        
                        if((!filterState | filterState?.toLowerCase() === state.state.toLowerCase())){
                                return (<AmbulanceItem 
                                    key={state.district}
                                    state={state.state}
                                    Ambulance={state.Ambulance}
                                    district={state.district}
                                    />)
                        }
                    })
                }
                    
                
            </div>
        </div>
    )
}

export default Ambulance
